import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  benefitRatingsMaxScale: 5,
  showStickyHeader: true,
  stickyHeader: {
    thumbnail: {
      height: 64,
      width: 64
    }
  },
} satisfies RecursivePartial<PdpConfig>
